import { render, staticRenderFns } from "./create-case-list-modal.vue?vue&type=template&id=10325238&scoped=true"
import script from "./create-case-list-modal.vue?vue&type=script&lang=js"
export * from "./create-case-list-modal.vue?vue&type=script&lang=js"
import style0 from "./create-case-list-modal.vue?vue&type=style&index=0&id=10325238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10325238",
  null
  
)

export default component.exports